import React from 'react';

const TemplateSelector = ({ templates, selectedTemplate, onTemplateChange }) => {
  return (
    <div className="form-section-content">
      <h3 className="section-title">Modèle de signature</h3>

      <div className="template-grid">
        {templates.map((template) => (
          <div
            key={template.id}
            className={`template-card ${selectedTemplate === template.id ? 'active' : ''}`}
            onClick={() => onTemplateChange(template.id)}
          >
            <h4>{template.name}</h4>
            <p>{template.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelector;